<script >
    export let count= 0;
</script>

<main>

    <input type="number" bind:value={count}>
    <button on:click="{() => count += 1}">Count</button>

</main>

<style>
	main{
    display: flex;
    justify-content: center;
		align-items: center;
	}
</style>